import { render } from "./KeyTable.vue?vue&type=template&id=4d45a2d6"
import script from "./KeyTable.vue?vue&type=script&lang=js"
export * from "./KeyTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__